import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import * as fromAuth from '@app-stores/reducers/auth';
import * as Auth from '@app-stores/actions/auth.action';
@Component({
	selector: 'crm-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit, OnDestroy {
	loading = false;
	errorMessage: string = '';
	getUser$ = this._store.pipe(select(fromAuth.getUser));
	// Private
	private _viewInited: boolean = false;
	private _unsubscribeAll: Subject<any>;
	constructor(
		private _router: Router,
		private _route: ActivatedRoute,
		private _store: Store<fromAuth.AuthState>,
	) {
		// Set the private defaults
		this._unsubscribeAll = new Subject();
	}
	ngOnInit() {
		this._unsubscribeAll = new Subject();
		this.getUser$
			.pipe(takeUntil(this._unsubscribeAll))
			.subscribe((res) => {
				if (res) {
				} else {
					this._router.navigate(['/']);
				}
			});
		this._viewInited = true;
		this._store.dispatch(new Auth.Logout());
	}
	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
